import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'

import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { SearchInput } from 'Components/Header/SearchInput'
import { styles } from './style'

import SimpleTableTable from 'Components/SimpleTableTable'
import Pagination from '../../../../../Components/FilterAndPaginationComponent/Pagination'
import { isDefined } from '../../../../../shared/libraries/utils/object'
import {
  BRAND_AMBASSADOR_STATUS_ENUM,
  INVITED_SPY_STATUS,
} from '../../../../../shared/constants'
import SubmitInput from '../SubmitInput/index'

export const STATUS_FILTER_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Invited', value: INVITED_SPY_STATUS },
  { label: 'Active', value: BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE },
  { label: 'Blocked', value: BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED },
]

const View = props => {
  const {
    data,
    handleSearch,
    setFilters,
    isLoading,
    search,
    filters,
    onOffsetChange,
    resultsPerPage,
    setResultsPerPage,
    totalCount,
    offsetRecordsStart,
    onInviteSpy,
    classes,
    isShowErrorOnInviteSpy,
  } = props

  const onSortSignUpDate = (a, b) => {
    // if a or b is not the right string its sorting it as the lowest date
    if (typeof a !== 'string' || !a.match(/\d{2}\/\d{2}\/\d{2}/)) {
      return 1
    }
    if (typeof b !== 'string' || !b.match(/\d{2}\/\d{2}\/\d{2}/)) {
      return -1
    }

    return moment(b, 'DD/MM/YYYY') - moment(a, 'DD/MM/YYYY')
  }

  return (
    <div>
      <FiltersWrapper className={classes.filterSearchWrapper}>
        <FilterBox>
          <SearchInput
            placeholder="Search anything"
            searchHandler={handleSearch}
            value={search}
          />
        </FilterBox>

        <div className={classes.filterWrapper}>
          <FilterBox>
            <FilterSelect
              hasPrimaryText={false}
              label="Status"
              onChange={(element, index, value) =>
                setFilters({ ...filters, 'status': value })
              }
              options={STATUS_FILTER_OPTIONS}
              value={filters.status}
              sorted={!!filters.status}
            />
          </FilterBox>

          <div>
            <SubmitInput
              onSubmit={onInviteSpy}
              buttonLabel={'Invite'}
              placeholder={'Spy email'}
              actionLabel={'Spy invited!'}
              disabled={isShowErrorOnInviteSpy}
              errorText={
                isShowErrorOnInviteSpy
                  ? 'Add recruitment calendar link in city setting for inviting spy'
                  : null
              }
            />
          </div>
        </div>
      </FiltersWrapper>

      <div className={props.classes.wrapperTable}>
        <SimpleTableTable
          data={data}
          header={[
            'Name',
            'Signup Date',
            'Phone Number',
            'Email',
            'Status',
            'Actions',
          ]}
          sortOn={['Name', { label: 'Signup Date', sort: onSortSignUpDate }]}
          showPages={false}
          loadingData={isLoading}
          cypress_id={'spyListTable'}
        />
      </div>
      <Pagination
        className={classes.pagination}
        total={isDefined(totalCount) ? totalCount : data.length}
        offset={isDefined(offsetRecordsStart) ? offsetRecordsStart : 0}
        resultsPerPage={
          isDefined(resultsPerPage) ? resultsPerPage : data.length
        }
        onOffsetChange={onOffsetChange}
        setResultsPerPage={setResultsPerPage}
      />
    </div>
  )
}

export default injectStyles(styles)(View)
